import { CampaignAgentPhones_campaign_agentPhones } from 'types/apollo/CampaignAgentPhones';
import { AgentPhoneStatus } from 'types/apollo/globalTypes';
import { isVendor, Vendor } from 'utils/vendor';
import { Data } from './agent-phones';

export type FilterStatus = AgentPhoneStatus | 'ALL';

interface Filters {
  search?: string;
  status?: string;
}

export function formatAgentPhone(agentPhone: CampaignAgentPhones_campaign_agentPhones): Data {
  return {
    id: `${agentPhone.phone}`,
    locality: agentPhone.locality,
    messagingServiceId: agentPhone.messagingServiceId,
    phone: agentPhone.phone,
    region: agentPhone.region,
    status: agentPhone.status,
    vendorId: agentPhone.vendorId,
  };
}

/** Numbers still carrying traffic; draining counts, which is what the buy dialog warns on. */
export function countLivePhones(agentPhones: CampaignAgentPhones_campaign_agentPhones[]): number {
  return agentPhones.filter((p) => p.status !== AgentPhoneStatus.INACTIVE).length;
}

/**
 * Draining is Telnyx-only (`telnyx/phone/:phone/drain`) and a no-op on an already-draining or
 * retired number.
 */
export function canDrain(row: Pick<Data, 'status' | 'vendorId'>): boolean {
  return isVendor(row.vendorId, Vendor.TELNYX) && row.status === AgentPhoneStatus.ACTIVE;
}

export const applyFilter = (
  { search, status }: Filters,
  agentPhones: CampaignAgentPhones_campaign_agentPhones[],
): Data[] => {
  let tableRows: Data[] = [];
  agentPhones.forEach((agentPhone) => {
    tableRows.push(formatAgentPhone(agentPhone));
  });

  if (search) {
    const lowerSearch = search.toLowerCase();
    tableRows = tableRows.filter(
      (agentPhone) =>
        agentPhone.phone.toLowerCase().includes(lowerSearch) ||
        agentPhone.locality.toLowerCase().includes(lowerSearch) ||
        agentPhone.region.toLowerCase().includes(lowerSearch),
    );
  }
  if (status !== 'ALL') {
    tableRows = tableRows.filter((agentPhone) => agentPhone.status === status);
  }

  return tableRows;
};
